import { render, staticRenderFns } from "./Scene1.vue?vue&type=template&id=01190c1c&"
import script from "./Scene1.vue?vue&type=script&lang=js&"
export * from "./Scene1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports